<template>
    <div class="heading__right_user">
        <button class="heading__right_user_logo" @click.prevent="clickLogoUser">
            {{ userFirstCharacter }}
        </button>
        <modal_logout
            v-if="isOpenLogout"
            :key="'modal_logout'"
            @click_logout="clickLogout"
        />
    </div>
</template>

<script>

import modal_logout from "./ModalLogout.vue";
import {eventsMouse} from "../../mixins/eventsMouse";
import {createHelpers} from "vuex-map-fields";


const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "logo_user",
    components: {modal_logout},
    mixins: [eventsMouse],
    data() {
        return {
            isOpenLogout: false,
        }
    },
    methods: {
        clickLogoUser() {
            this.isOpenLogout = true;
        },
        clickLogout() {
            this.isOpenLogout = false;
            this.$store.dispatch('user/LOGOUT_USER');
        },
        mouseDownClick(event) {
            const arrayWatchClass = ['heading__logout', 'heading__logout_text']
            let clickWatchElement = false;
            event.target.classList.forEach(item => {
                if (arrayWatchClass.includes(item)) {
                    clickWatchElement = true;
                }
            })
            if (this.isOpenLogout && !clickWatchElement) {
                this.isOpenLogout = false;
            }
        },
    },
    computed: {
        ...mUser([
            'user',
        ]),
        userFirstCharacter() {
            if (this.user.client.organization && this.user.client.organization !== '') {
                return this.user.client.organization[0].toUpperCase();
            }
            return '';
        }
    },
}
</script>
